import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import Text from '../Text';
import { useState } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { api } from '../../maps/data.js';
import Icn from '../Icn';
import SensorsPage from '../../routes/admin/SensorsPage';

export default function InstallerDialog(props) {
    const { open, onClose } = props;
    const newUser = !Object.keys(open).length;
    const [name, s_name] = useState(open.name || '');

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <SensorsPage distributorShowInstallerSensors={true} installer={props.installer} />
        </Dialog>)
}